import { Routes } from '@angular/router';
import {
  CmsPageComponent,
  cmsPageTemplateResolver,
  cmsSeoDataResolver,
} from '@domgen/dgx-fe-cms';
import { RegistrationGaCategory } from '@us-registration/util-models';

export const REGISTRATION_FEATURE_CHECKOUT_ROUTES: Routes = [
  {
    path: '',
    component: CmsPageComponent,
    data: {
      cmsNodePath: '/checkout',
      gaData: {
        category: RegistrationGaCategory.Pages,
      },
    },
    resolve: {
      cmsPageTemplate: cmsPageTemplateResolver,
      seoData: cmsSeoDataResolver,
    },
  },
];
